export function normalizeProcessingError(errorInput) {
  if (!errorInput) return null;
  if (typeof errorInput === 'object') return errorInput;
  try {
    const parsed = JSON.parse(errorInput);
    if (parsed && typeof parsed === 'object') return parsed;
  } catch {}
  return { message: String(errorInput) };
}

export function getProcessingStatus(value) {
  return String(value?.processing_status || value?.status || '').toLowerCase();
}

export function isRetryableProcessingError(errorInput) {
  const parsed = normalizeProcessingError(errorInput);
  return parsed?.retryable === true;
}

export function isRecoverableProcessingFailure(value) {
  return getProcessingStatus(value) === 'failed' && isRetryableProcessingError(value?.processing_error || value?.error);
}

export function isTerminalProcessingFailure(value) {
  const status = getProcessingStatus(value);
  if (status !== 'failed') return false;
  return !isRecoverableProcessingFailure(value);
}

export function isProcessingLike(value) {
  const status = getProcessingStatus(value);
  if (!status || status === 'ready') return false;
  if (status === 'failed') return isRecoverableProcessingFailure(value);
  return true;
}
